module.exports = __webpack_public_path__ + "img/ability-lab.c426c3c0.svg";